var _rect, _circle, _path, _path2, _rect2, _rect3, _g, _path3, _rect4, _mask, _path4, _path5, _rect5, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 110,
    viewBox: "0 0 107 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25_122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 107,
    height: 110
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 110,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25_122)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 53.5,
    r: 53.5,
    fill: "url(#paint0_radial_25_122)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6648 29.5423C55.4223 28.7798 53.4837 19.2942 49.0128 16.3433C44.5419 13.3923 38.3739 13.5603 35.2362 16.7186C32.0984 19.8769 33.1792 24.8294 37.6501 27.7803C42.121 30.7313 53.9073 30.3048 54.6648 29.5423ZM53.5856 28.8299C54.11 28.3021 52.1813 21.348 48.704 19.0528C45.2266 16.7576 40.6467 16.6694 38.4744 18.8559C36.3021 21.0424 37.3601 24.6755 40.8375 26.9708C44.3148 29.266 53.0611 29.3578 53.5856 28.8299Z",
    fill: "url(#paint1_radial_25_122)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.699 30.0356C55.0627 29.3951 56.6911 21.4272 60.4467 18.9484C64.2022 16.4696 69.3833 16.6107 72.019 19.2637C74.6547 21.9166 73.7469 26.0767 69.9914 28.5556C66.2358 31.0344 56.3353 30.6761 55.699 30.0356ZM56.6056 29.4372C56.1651 28.9938 57.7851 23.1524 60.7061 21.2244C63.6271 19.2964 67.4743 19.2224 69.299 21.059C71.1237 22.8957 70.235 25.9475 67.314 27.8755C64.393 29.8035 57.0461 29.8806 56.6056 29.4372Z",
    fill: "url(#paint2_radial_25_122)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 41,
    width: 56,
    height: 43,
    rx: 2,
    fill: "url(#paint3_linear_25_122)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_25_122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 41,
    width: 56,
    height: 43
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 41,
    width: 56,
    height: 43,
    rx: 2,
    fill: "url(#paint4_linear_25_122)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_25_122)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -1.06066,
    y1: 71.4577,
    x2: 60.4576,
    y2: 9.93936,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.06066,
    y1: 71.4577,
    x2: 60.4576,
    y2: 9.93936,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.18195,
    y1: 75.7003,
    x2: 64.7002,
    y2: 14.182,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.18195,
    y1: 75.7003,
    x2: 64.7002,
    y2: 14.182,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.42463,
    y1: 79.9429,
    x2: 68.9429,
    y2: 18.4246,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.42463,
    y1: 79.9429,
    x2: 68.9429,
    y2: 18.4246,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.6673,
    y1: 84.1856,
    x2: 73.1856,
    y2: 22.6673,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.6673,
    y1: 84.1856,
    x2: 73.1856,
    y2: 22.6673,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.9099,
    y1: 88.4282,
    x2: 77.4282,
    y2: 26.9099,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.9099,
    y1: 88.4282,
    x2: 77.4282,
    y2: 26.9099,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.1525,
    y1: 92.6709,
    x2: 81.6708,
    y2: 31.1526,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.1525,
    y1: 92.6709,
    x2: 81.6708,
    y2: 31.1526,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.3952,
    y1: 96.9135,
    x2: 85.9135,
    y2: 35.3952,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.3952,
    y1: 96.9135,
    x2: 85.9135,
    y2: 35.3952,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.6378,
    y1: 101.156,
    x2: 90.1561,
    y2: 39.6378,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.6378,
    y1: 101.156,
    x2: 90.1561,
    y2: 39.6378,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.8805,
    y1: 105.399,
    x2: 94.3988,
    y2: 43.8805,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.8805,
    y1: 105.399,
    x2: 94.3988,
    y2: 43.8805,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.1231,
    y1: 109.641,
    x2: 98.6414,
    y2: 48.1231,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.1231,
    y1: 109.641,
    x2: 98.6414,
    y2: 48.1231,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.3657,
    y1: 113.884,
    x2: 102.884,
    y2: 52.3658,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.3657,
    y1: 113.884,
    x2: 102.884,
    y2: 52.3658,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.6084,
    y1: 118.127,
    x2: 107.127,
    y2: 56.6084,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.6084,
    y1: 118.127,
    x2: 107.127,
    y2: 56.6084,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.851,
    y1: 122.369,
    x2: 111.369,
    y2: 60.8511,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.851,
    y1: 122.369,
    x2: 111.369,
    y2: 60.8511,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.0937,
    y1: 126.612,
    x2: 115.612,
    y2: 65.0937,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.0937,
    y1: 126.612,
    x2: 115.612,
    y2: 65.0937,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.3363,
    y1: 130.855,
    x2: 119.855,
    y2: 69.3363,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.3363,
    y1: 130.855,
    x2: 119.855,
    y2: 69.3363,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.579,
    y1: 135.097,
    x2: 124.097,
    y2: 73.579,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.579,
    y1: 135.097,
    x2: 124.097,
    y2: 73.579,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.8216,
    y1: 139.34,
    x2: 128.34,
    y2: 77.8216,
    stroke: "#FFB800",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.8216,
    y1: 139.34,
    x2: 128.34,
    y2: 77.8216,
    stroke: "#FFB800",
    strokeWidth: 3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 30C50 28.3431 51.3431 27 53 27H55C56.6569 27 58 28.3431 58 30V32C58 32.5523 57.5523 33 57 33H51C50.4477 33 50 32.5523 50 32V30Z",
    fill: "url(#paint5_linear_25_122)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 31,
    width: 62,
    height: 15,
    rx: 2,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-26-inside-1_25_122",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 31C47 30.4477 47.4477 30 48 30H60C60.5523 30 61 30.4477 61 31V84C61 84.5523 60.5523 85 60 85H48C47.4477 85 47 84.5523 47 84V31Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 31C47 30.4477 47.4477 30 48 30H60C60.5523 30 61 30.4477 61 31V84C61 84.5523 60.5523 85 60 85H48C47.4477 85 47 84.5523 47 84V31Z",
    fill: "url(#paint6_linear_25_122)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47 30H61H47ZM61 85H47H61ZM48 85C47.1716 85 46.5 84.3284 46.5 83.5V31.5C46.5 30.6716 47.1716 30 48 30C47.7239 30 47.5 30.4477 47.5 31V84C47.5 84.5523 47.7239 85 48 85ZM61 30V85V30Z",
    fill: "#E2AB03",
    mask: "url(#path-26-inside-1_25_122)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 46,
    width: 14,
    height: 4,
    fill: "url(#paint7_linear_25_122)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_25_122)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 32C34 30.3431 35.3431 29 37 29H46H48H51C51.7403 29 52.3866 29.4022 52.7324 30H51C49.3431 30 48 31.3431 48 33V34V49.6743C48 50.3386 47.3641 50.8183 46.7253 50.6358L41.2747 49.0785C41.0952 49.0272 40.9048 49.0272 40.7253 49.0785L35.2747 50.6358C34.6359 50.8183 34 50.3386 34 49.6743V32Z",
    fill: "url(#paint8_linear_25_122)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_25_122)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7324 32C73.7324 30.3431 72.3893 29 70.7324 29H61.7324H59.7324H56.7324C55.9921 29 55.3458 29.4022 55 30H56.7324C58.3893 30 59.7324 31.3431 59.7324 33V34V57.6743C59.7324 58.3386 60.3683 58.8183 61.0071 58.6358L66.4577 57.0785C66.6373 57.0272 66.8276 57.0272 67.0071 57.0785L72.4577 58.6358C73.0965 58.8183 73.7324 58.3386 73.7324 57.6743V32Z",
    fill: "url(#paint9_linear_25_122)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_25_122",
    x: 33,
    y: 28,
    width: 22.7324,
    height: 25.6749,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6375 0 0 0 0 0.310144 0 0 0 0 0.00796875 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_122",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_25_122",
    x: 52,
    y: 28,
    width: 22.7324,
    height: 33.6749,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6375 0 0 0 0 0.310144 0 0 0 0 0.00796875 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_122",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_25_122",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.5 53.5) rotate(90) scale(53.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD811E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_25_122",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43 21.5994) rotate(33.418) scale(12.5797 9.54425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360687,
    stopColor: "#FFF09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55745,
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_25_122",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.4974 23.3635) rotate(146.582) scale(10.567 8.01717)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360687,
    stopColor: "#FFF09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55745,
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25_122",
    x1: 54,
    y1: 42.217,
    x2: 54,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209479,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463719,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE7C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_25_122",
    x1: 54,
    y1: 42.217,
    x2: 54,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209479,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463719,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE7C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_25_122",
    x1: 54,
    y1: 29.25,
    x2: 54,
    y2: 30.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_25_122",
    x1: 54,
    y1: 50.625,
    x2: 54,
    y2: 65.2917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_25_122",
    x1: 54,
    y1: 46,
    x2: 54,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD705"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_25_122",
    x1: 43.3662,
    y1: 29,
    x2: 43.3662,
    y2: 49.6897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#FFF09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_25_122",
    x1: 64.3662,
    y1: 29,
    x2: 64.3662,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#FFF09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftImage);
export default __webpack_public_path__ + "static/media/gift-image.99062567.svg";
export { ForwardRef as ReactComponent };